export default __webpack_public_path__ + "static/6_months-2dd282375b9b7e564431161fcdd441db.jpeg";